export default class ReleaseSchedule {
  constructor(client) {
    this.client = client;
    this.resourceUrl = "/poeReleaseSchedule";
  }

  getAllReleaseSchedules() {
    return this.client.get(`${this.resourceUrl}`);
  }

  getReleaseScheduleDetails(poeReleaseScheduleId) {
    return this.client.get(`${this.resourceUrl}/${poeReleaseScheduleId}`);
  }

  createReleaseSchedule(releaseSchedule) {
    return this.client.post(`${this.resourceUrl}`, releaseSchedule);
  }

  getPolicyMappingDetails(releaseKey) {
    return this.client.get(`${this.resourceUrl}/getPolicies/${releaseKey}`);
  }

  addPoliciesToRelease(poeReleaseScheduleId, policies) {
    return this.client.post(
      `${this.resourceUrl}/${poeReleaseScheduleId}/policies`,
      policies
    );
  }

  deletePoliciesFromRelease(poeReleaseScheduleId, policies) {
    return this.client.post(
      `${this.resourceUrl}/delete/${poeReleaseScheduleId}/policies`,
      policies
    );
  }
}
